export default __webpack_public_path__ + "static/media/pic38.869289e3.jpg";